import React, { useMemo } from 'react';
import { List, ListItem, ListItemTitle } from '@ds';
import Popover from '@mui/material/Popover';
import sortBy from 'lodash/sortBy';

import { DSOpenInNewIcon } from '@ds-icons';
import typography from '@ds-typography';

interface ReferencedProject {
  workspaceName: string;
  projectName: string;
}

interface SymlinkedExperimentsPopoverProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  referencedProjects?: ReferencedProject[];
}

const SymlinkedExperimentsPopover: React.FC<SymlinkedExperimentsPopoverProps> = ({
  anchorEl,
  onClose,
  referencedProjects = []
}) => {
  const open = Boolean(anchorEl);

  const sortedProjects = useMemo(
    () => sortBy(referencedProjects, ['workspaceName', 'projectName']),
    [referencedProjects]
  );

  return (
    <Popover
      classes={{
        paper: 'symlinked-to-popover'
      }}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
    >
      <List>
        <ListItemTitle
          text="Symlinked to projects"
          className={typography.dsBodySmall}
        />
        {sortedProjects.map(project => (
          <a
            href={`/${project.workspaceName}/${project.projectName}`}
            target="_blank"
            rel="noopener noreferrer"
            key={`${project.workspaceName}-${project.projectName}`}
          >
            <ListItem>
              <ListItem.Text
                primary={project.projectName}
                secondary={project.workspaceName}
              />

              <ListItem.ActionContainer>
                <ListItem.Action Icon={<DSOpenInNewIcon />} />
              </ListItem.ActionContainer>
            </ListItem>
          </a>
        ))}
      </List>
    </Popover>
  );
};

export default SymlinkedExperimentsPopover;
